import { getCaseAndChargeCounts, getScraperDetails, getSourceCaseTypeInfo, getSourceCaseTypeInfosAggregateBySource, addMonitoringOrders, getSourceSymptomsInfo, forceUpdateMonitoringOrder, getStateDetails } from '../api/GetScraperDetails';

const requestScraperDetailType = 'REQUEST_SCRAPER_DETAIL';
const receiveScraperDetailType = 'RECEIVE_SCRAPER_DETAIL';

const requestStateDetailType = 'REQUEST_STATE_DETAIL';
const receiveStateDetailType = 'RECEIVE_STATE_DETAIL';

const requestCaseAndChargeCountsType = 'REQUEST_CASE_AND_CHARGE_COUNTS';
const receiveCaseAndChargeCountsType = 'RECEIVE_CASE_AND_CHARGE_COUNTS';

const requestCaseAndChargeCountsAllType = 'REQUEST_CASE_AND_CHARGE_COUNTS_ALL';
const receiveCaseAndChargeCountsAllType = 'RECEIVE_CASE_AND_CHARGE_COUNTS_ALL';

const requestSourceCaseTypeInfoType = 'REQUEST_SOURCE_CASE_TYPE_INFO';
const receiveSourceCaseTypeInfoType = 'RECEIVE_SOURCE_CASE_TYPE_INFO';

const requestSourceCaseTypeInfoAggregateBySourceType = 'REQUEST_SOURCE_CASE_TYPE_AGGREGATE_BY_SOURCEINFO';
const receiveSourceCaseTypeInfoAggregateBySourceType = 'RECEIVE_SOURCE_CASE_TYPE_AGGREGATE_BY_SOURCEINFO';

const requestSourceCaseTypeInfoAllType = 'REQUEST_SOURCE_CASE_TYPE_INFO_ALL';
const receiveSourceCaseTypeInfoAllType = 'RECEIVE_SOURCE_CASE_TYPE_INFO_ALL';

const requestSourceCaseTypeInfoAggregateBySourceAllType = 'REQUEST_SOURCE_CASE_TYPE_INFO_AGGREGATE_BY_SOURCE_ALL';
const receiveSourceCaseTypeInfoAggregateBySourceAllType = 'RECEIVE_SOURCE_CASE_TYPE_INFO_AGGREGATE_BY_SOURCE_ALL';

const requestSourceSymptomsInfoType = 'REQUEST_SOURCE_SYMPTOMS_INFO';
const receiveSourceSymptomsInfoType = 'RECEIVE_SOURCE_SYMPTOMS_INFO';

const requestSourceSymptomsInfoAllType = 'REQUEST_SOURCE_SYMPTOMS_INFO_ALL';
const receiveSourceSymptomsInfoAllType = 'RECEIVE_SOURCE_SYMPTOMS_INFO_ALL';



const initialState = {
    scraperConfigModel: {}, scraperDetailDataItems: [], sourceDateTimeDataPoints: [], stateDateTimeDataPoints: [], stateDateTimeDataPointsCourts: [], stateDateTimeDataPointsArrests: [], 
    sourceCaseTypeInfo: [], sourceCaseTypeInfoAll: [], sourceCaseTypeInfoAllByFips: [],
    sourceCaseTypeMessagesAll: [], sourceCaseTypeMessages: [],
    sourceCaseTypeInfoAggregateBySource: [], sourceCaseTypeInfoAggregateBySourceAll: [],
    sourceCaseAndChargeCounts: [], sourceCaseAndChargeCountsAll: [],
    sourceSymptomsInfoAll: [], sourceSymptomsInfo: [], isLoading: false
};

export const actionCreators = {
    requestCaseAndChargeCounts: (ossId) => async (dispatch, getState) => {
        dispatch({ type: requestCaseAndChargeCountsType });

        let errorMessage = `Could not load OSS ID '${ossId}'; Try Refreshing The Webpage.`;
        getCaseAndChargeCounts(ossId).then(data => {
            if (!ossId)
                dispatch({ type: receiveCaseAndChargeCountsAllType, data: { sourceCaseAndChargeCountsAll: data }, errorMessage: data == null ? errorMessage : null });
            else
                dispatch({ type: receiveCaseAndChargeCountsType, data: { sourceCaseAndChargeCounts: data }, errorMessage: data == null ? errorMessage : null });

        }).catch(ex => {
            if (!ossId)
                dispatch({ type: receiveCaseAndChargeCountsAllType, data: { sourceCaseAndChargeCountsAll: [] }, errorMessage: errorMessage })
            else 
                dispatch({ type: receiveCaseAndChargeCountsType, data: { sourceCaseAndChargeCounts: [] }, errorMessage: errorMessage })
        });
    },

    requestStateDetail: (stateAbbreviation) => async (dispatch, getState) => {
        dispatch({ type: requestStateDetailType });

        let errorMessage = `There was an issue loading the state information; please try again later.`;
        getStateDetails(stateAbbreviation).then(data => {
            dispatch({ type: receiveStateDetailType, data, errorMessage: data == null ? errorMessage : null });
        }).catch(ex => {
            dispatch({ type: receiveStateDetailType, data: {}, errorMessage: errorMessage })
        });
    },

    requestScraperDetail: (ossId) => async (dispatch, getState) => {
        dispatch({ type: requestScraperDetailType });

        let errorMessage = `Could not load OSS ID '${ossId}'; Try Refreshing The Webpage.`;
        getScraperDetails(ossId).then(data => {
            dispatch({ type: receiveScraperDetailType, data, errorMessage: data == null ? errorMessage : null });
        }).catch(ex => {
            dispatch({ type: receiveScraperDetailType, data: {}, errorMessage: errorMessage })
        });        
    },
    requestSourceCaseTypeInfos: (ossId) => async (dispatch, getState) => {
        let errorMessage = `Could not load case type infos for OSS ID '${ossId}'; Try Refreshing The Webpage.`;
        dispatch({ type: requestSourceCaseTypeInfoType });
        getSourceCaseTypeInfo(ossId).then(data => {
            if (!ossId)
                dispatch({ type: receiveSourceCaseTypeInfoAllType, data: { sourceCaseTypeInfoAll: data.sourceCaseTypeInfos, sourceCaseTypeInfoAllByFips: data.sourceCaseTypeInfosByFips, sourceCaseTypeMessagesAll: data.messages }, errorMessage: data == null ? errorMessage : null });
            else
                dispatch({ type: receiveSourceCaseTypeInfoType, data: { sourceCaseTypeInfo: data.sourceCaseTypeInfos, sourceCaseTypeMessages: data.messages }, errorMessage: data == null ? errorMessage : null });
        }).catch(ex => {
            if (!ossId)
                dispatch({ type: receiveSourceCaseTypeInfoAllType, data: { sourceCaseTypeInfoAll: [], sourceCaseTypeInfoAllByFips: [], sourceCaseTypeMessagesAll: [] }, errorMessage: errorMessage });
            else
                dispatch({ type: receiveSourceCaseTypeInfoType, data: { sourceCaseTypeInfo: [], sourceCaseTypeMessages: [] }, errorMessage: errorMessage });
        });
    },
    requestSourceCaseTypeInfosAggregateBySource: (ossId) => async (dispatch, getState) => {
        let errorMessage = `Could not load case type infos for OSS ID '${ossId}'; Try Refreshing The Webpage.`;
        dispatch({ type: requestSourceCaseTypeInfoAggregateBySourceType });
        getSourceCaseTypeInfosAggregateBySource(ossId).then(data => {
            if (!ossId)
                dispatch({ type: receiveSourceCaseTypeInfoAggregateBySourceAllType, data: { sourceCaseTypeInfoAggregateBySourceAll: data.sourceCaseTypeInfos}, errorMessage: data == null ? errorMessage : null });
            else
                dispatch({ type: receiveSourceCaseTypeInfoAggregateBySourceType, data: { sourceCaseTypeInfoAggregateBySource: data.sourceCaseTypeInfos }, errorMessage: data == null ? errorMessage : null });
        }).catch(ex => {
            if (!ossId)
                dispatch({ type: receiveSourceCaseTypeInfoAggregateBySourceAllType, data: { sourceCaseTypeInfoAggregateBySourceAll: []}, errorMessage: errorMessage });
            else
                dispatch({ type: receiveSourceCaseTypeInfoAggregateBySourceType, data: { sourceCaseTypeInfoAggregateBySource: []}, errorMessage: errorMessage });
        });
    },
    

    requestSourceSymptomsInfos: (ossId) => async (dispatch, getState) => {
        let errorMessage = `Could not load case type infos for OSS ID '${ossId}'; Try Refreshing The Webpage.`;
        dispatch({ type: requestSourceSymptomsInfoType });
        getSourceSymptomsInfo(ossId).then(data => {
            if (!ossId)
                dispatch({ type: receiveSourceSymptomsInfoAllType, data: { sourceSymptomsInfoAll: data.sourceSymptomsInfos }, errorMessage: data == null ? errorMessage : null });
            else
                dispatch({ type: receiveSourceSymptomsInfoType, data: { sourceSymptomsInfo: data.sourceSymptomsInfos }, errorMessage: data == null ? errorMessage : null });
        }).catch(ex => {
            if (!ossId)
                dispatch({ type: receiveSourceSymptomsInfoAllType, data: { sourceSymptomsInfoAll: [], sourceSymptomsMessagesAll: [] }, errorMessage: errorMessage });
            else
                dispatch({ type: receiveSourceSymptomsInfoType, data: { sourceSymptomsInfo: [], sourceSymptomsMessages: [] }, errorMessage: errorMessage });
        });
    },

    addMonitoringOrders: (orders) => async (dispatch, getState) => {
        addMonitoringOrders(orders).then(data => {
            // todo make the ui cool
        });
    },
    forceUpdateMonitoringOrder: (personId) => async (dispatch, getState) => {
        forceUpdateMonitoringOrder(personId).then(data => {
            // todo make the ui cool
        });
    },
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestScraperDetailType
        || action.type === requestStateDetailType
        || action.type === requestSourceCaseTypeInfoType
        || action.type === requestSourceCaseTypeInfoAggregateBySourceType
        || action.type === requestCaseAndChargeCountsAllType
        || action.type === requestCaseAndChargeCountsType) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveScraperDetailType ||
        action.type === receiveStateDetailType ||
        action.type == receiveSourceCaseTypeInfoType
     || action.type == receiveSourceCaseTypeInfoAllType
     || action.type == receiveSourceSymptomsInfoType
        || action.type === receiveSourceSymptomsInfoAllType
        || action.type === receiveSourceCaseTypeInfoAggregateBySourceAllType
        || action.type === receiveSourceCaseTypeInfoAggregateBySourceType
        || action.type === receiveCaseAndChargeCountsAllType
        || action.type === receiveCaseAndChargeCountsType) {
        return {
            ...state,
            ...action.data,
            errorMessage: action.errorMessage,
            isLoading: false
        };
    }

    return state;
};